// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__2jeHA","link":"footer_link__3tKm7"};